<style type="text/css">
  p-sidebar .ui-tree {
    border: none !important;
    border-left: none !important;
    background-color: blue;
    width: 100% !important;
  }

  html, body {
    height: 95%;
  }

  body {
    display: flex;
  }

  .split-example {
    height: 88vh;
    overflow: auto;
  }

  .selectableDiv {
    /*border: solid 1px gray;*/
    margin: 4px;
    padding: 5px;
  }

    .selectableDiv:hover {
      -webkit-box-shadow: 0 0 5px #27AE61;
      -moz-box-shadow: 0 0 5px #27AE61;
      box-shadow: 0 0 5px #27AE61;
    }
</style>

<div style="margin: -15px;">
  <div class="split-example">
    <as-split direction="horizontal" (dragStart)="showIframeHider = true" (dragEnd)="showIframeHider = false">
      <as-split-area size="20">
        <div>
          <p-accordion (onOpen)="onTabOpen($event)" value="0">
            <p-accordion-panel *hasClaim="'User_View'" value="1">
              <p-accordion-header style="{'background-color': '#7b95a3 !important'}" class="darkHeader">
                <div>
                  Users
                </div>
              </p-accordion-header>
              <p-accordion-content>
                <div style="width:100%;max-height:400px; overflow-y:auto; margin-right:-14px">
                  <div style="width:90%; margin-top:8px; margin-left:8px;">
                    ...showing users...
                  </div>
                </div>
              </p-accordion-content>
            </p-accordion-panel>
            <p-accordion-panel *hasClaim="'Client_View'" value="2">
              <p-accordion-header style="{'background-color': '#7b95a3 !important'}" class="darkHeader">
                <div>
                  Clients
                </div>
              </p-accordion-header>
              <p-accordion-content>
                <div style="width:100%;max-height:400px; overflow-y:auto; margin-right:-14px">
                  <div style="width:90%; margin-top:8px; margin-left:8px;">
                    ...showing clients...
                  </div>
                </div>
              </p-accordion-content>
            </p-accordion-panel>
            <!--<p-accordion-panel header="Labs & Panels">
              <div style="width:100%;max-height:400px; overflow-y:auto; margin-right:-14px">
                <div class="selectableDiv" style="color:darkblue" [ngClass]="{'selectedDiv': selid === 0 && seltype === 'l' }" (click)="showLab(this, 'l,0', labtree)">Add a new lab</div>
                <tree-root #labtree [nodes]="treenodes" [options]="treeoptions" (activate)="treeNodeActivated($event, labtree)">
                  <ng-template #treeNodeWrapperTemplate let-node let-index="index">
                    <div class="node-wrapper" [style.padding-left]="node.getNodePadding()">
                      <tree-node-expander [node]="node"></tree-node-expander>
                      <div class="node-content-wrapper"
                           [class.node-content-wrapper-active]="node.isActive"
                           [class.node-content-wrapper-focused]="node.isFocused"
                           (click)="node.mouseAction('click', $event)">
                        <i class="fa {{node.data.icon}}"></i>&nbsp;{{node.data.name}}
                      </div>
                    </div>
                  </ng-template>
                </tree-root>
              </div>
            </p-accordion-panel>
            <p-accordion-panel header="Tests">
              <div style="width:100%;max-height:400px; overflow-y:auto; margin-right:-14px">
                <div style="width:90%; margin-top:8px; margin-left:8px;">
                  <input type="text" [(ngModel)]="testSearchString" style="width:70%" placeholder="Search For tests" />
                  <a style="cursor: pointer; margin-left:5px;" (click)="doTestSearch()"><i class="fa fa-search"></i></a>
                  <a style="cursor: pointer; margin-left:5px;" (click)="createNewTest()"><i class="fa fa-plus"></i></a>
                </div>
                <div class="selectableDiv" *ngFor="let test of tests" [ngClass]="{'selectedDiv': selid === test.Id && seltype === 't' }" (click)="showLab(this, 't,' + test.Id, labtree)">{{test.Name}}</div>
              </div>
            </p-accordion-panel>
            <p-accordion-panel header="QA Setup">
              <div style="width:100%;max-height:400px; overflow-y:auto; margin-right:-14px">
                <div class="selectableDiv" (click)="createTestOrders()">Create MT21 Orders</div>
              </div>
            </p-accordion-panel>-->
          </p-accordion>
        </div>
      </as-split-area>
      <as-split-area size="80">
        <div class="m-3 overflow-auto" style="height:96%">
          <div #container></div>
          <router-outlet name="outUser"></router-outlet>
        </div>
      </as-split-area>
    </as-split>
  </div>

  <!--<p-dialog [(visible)]="linkTestVisible">
    <ng-template #header>
      Add test to panel
    </ng-template>
    <div style="min-width:250px; margin-top:8px; margin-left:8px;">
      <input type="text" [(ngModel)]="testSearchString" style="width:70%" placeholder="Search For tests" />
      <a style="cursor: pointer; margin-left:5px;" (click)="doTestSearch()"><i class="fa fa-search"></i></a>
    </div>
    <div class="selectableDiv" *ngFor="let test of linkTests" (click)="addPanelTestLink(test.Id, labtree)">{{test.Name}}</div>
    <ng-template #footer>
      //buttons
    </ng-template>
  </p-dialog>-->
</div>
